import { useEffect, useMemo, useState } from 'react'
import { useGridBlock } from '../../../contexts'
import { ILayout6 } from '../../../types'
import { Poster } from '../../Ads'
import ComponentTitle from '../../ComponentTitle/ComponentTitle'
import {
  Container,
  PostContainer,
  PosterWrap,
  StyledPost,
} from './Layout6.styles'
import { isDesktop } from '../../../client'

type Props = {
  layout: ILayout6
}

export const Layout6 = ({ layout }: Props) => {
  const posts = useMemo(() => layout.posts.slice(0, 6), [layout.posts]) // Only keep the first 6 posts
  const { grid_title, adUnit, layout_mobile } = layout
  const { gridId } = useGridBlock()
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  return posts ? (
    <Container key={gridId + 'Layout6'}>
      <ComponentTitle componentTitle={grid_title} />
      <PostContainer>
        {posts.map((post, index) => (
          <StyledPost
            key={index + '-' + post.id}
            layoutMobile={layout_mobile}
            post={post}
            height='307px'
            maxLines={3}
          />
        ))}
        {(() => {
          if (!isMounted || !isDesktop()) {
            return null
          }
          switch (adUnit) {
            case 'Poster':
              return (
                <PosterWrap>
                  <Poster />
                </PosterWrap>
              )
            case 'trio_ad_unit':
            default:
              return null
          }
        })()}
      </PostContainer>
    </Container>
  ) : null
}
